import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const styles = {};

export const overrides = {
	'.BlogCard-root': {
		backgroundColor: '#fff',
		display: 'flex',
		flexDirection: 'column',
		minHeight: remCalc(602),
		'&.contentless': {
			minHeight: 'unset',
		},
		overflow: 'hidden',
        height: "100%",

        '&.no-media': {
        	minHeight: 'unset',
        },
		'.BlogCard-mediaLink': {
			textDecoration: 'none',
		},
		'.BlogCard-media': {
			// aspectRatio: '549 / 309',
			overflow: 'hidden',
			position: 'relative',
			backgroundColor: getColor('ivory', 500),
		},
		'.BlogCardImage-root, .BlogCardImage-figure, .BlogCardImage-pictureContainer, .BlogCardImage-pictureElement, .BlogCardImage-fallbackImage': {
			width: '100%',
			height: '100%',
		},
		'.BlogCardImage-fallbackImage': {
			objectFit: 'cover',
		},
		'.BlogCard-mediaFallback': {
			width: '100%',
			height: '100%',
			backgroundColor: getColor('ivory', 500),
		},
		'.BlogCard-content': {
			alignItems: 'center',
			display: 'flex',
			flex: '1 0 auto',
			flexDirection: 'column',
			gap: remCalc(40),
			justifyContent: 'center',
			padding: `${remCalc(64)} ${remCalc(32)}`,
			textAlign: 'center',
			[theme.breakpoints.up('md')]: {
				padding: `${remCalc(80)} ${remCalc(40)}`,
			},
		},
		'.BlogCard-title': {
			color: getColor('ivory', 700),
			fontWeight: 400,
			margin: 0,

			'a': {
				color: 'inherit',
				textDecoration: 'none',
				fontWeight: 400,
			},
		},
		'.BlogCard-intro': {
			color: getColor('ivory', 600),
			display: '-webkit-box',
			fontFamily: 'var(--font-brandon-grotesque)',
			fontSize: remCalc(20),
			fontStyle: 'italic',
			fontWeight: 400,
			letterSpacing: remCalc(0.5),
			lineHeight: remCalc(26),
			margin: 0,
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			p: {
				margin: 0,
			}
		},
		'.BlogCard-ctaBar': {
			alignItems: 'center',
			backgroundColor: getColor('ivory', 400),
			display: 'flex',
			justifyContent: 'center',
			padding: `${remCalc(20)} ${remCalc(16)}`,
			textDecoration: 'none',
		},
		'.BlogCard-cta': {
			alignItems: 'center',
			color: getColor('ivory', 600),
			columnGap: remCalc(20),
			display: 'inline-flex',
			borderBottom: `1px solid transparent`,
			transition: 'all var(--transition-duration) ease-in-out',
		},
		'.BlogCard-ctaText': {
			fontFamily: 'var(--font-brandon-grotesque)',
			fontSize: remCalc(16),
			fontWeight: 420,
			letterSpacing: remCalc(2),
			lineHeight: remCalc(20),
			textTransform: 'uppercase',
		},
		'.BlogCard-ctaIcon': {
			width: remCalc(10),
			height: remCalc(18),
		},

		'&:hover, &:focus-within': {
			'.BlogCard-title, .BlogCard-cta': {
				color: getColor('ivory', 700),
			},
			'.BlogCard-cta': {
				borderBottomColor: getColor('ivory', 700),
			},
		},
		'.BlogCard-title a:focus-visible, .BlogCard-cta:focus-visible': {
			outline: `2px solid ${getColor('ivory', 700)}`,
			outlineOffset: remCalc(2),
		},
	},
};

export default styles;
